module.exports = __webpack_public_path__ + "static/media/apple_bag_1.4e2ddd71.png";